import { useApiQuery } from '../../../../../core/api/useApiQuery';
import { fetchDailyRatingsReportByPeriod, fetchSmilyReportByPeriod, fetchTopicSummaryReportByPeriod } from '../fetchSurveyReport';
import { Report, SmilyValueTypes } from '../smilyTypes';
import { Report as dailyRatingReport } from '../dailyRating';

import { SatisfactionResponsesGraf } from './SatisfactionResponsesGraf';
import { SelectSurvey } from './SelectSurvey';
import { Smily } from './Smily';
import { Box } from '@mui/system';
import { SatisfactionResponsesWordCloud } from './SatisfactionResponsesWordCloud';


const smilyReportData: Report = {
    "reportDetails": {
        "startDate": "2023-02-26",
        "endDate": "2023-04-25",
        "reportTime": "2023-04-12T15:46:30.081"
    },
    "reportSummary": {
        "averageScore": 3.5,
        "value": SmilyValueTypes.GOOD,
        "numberOfRatings": 150
    },
    "smileys":
        [
            {
                "value": SmilyValueTypes.VERYBAD,
                "score": 1,
                "numberOfRatings": 120
            },
            {
                "value": SmilyValueTypes.POOR,
                "score": 3,
                "numberOfRatings": 2
            },
            {
                "value": SmilyValueTypes.EXCELLENT,
                "score": 5,
                "numberOfRatings": 452
            }
        ]
}



const dailyRatingReportData: dailyRatingReport = {
    "reportDetails": {
        "startDate": "2023-02-26",
        "endDate": "2023-04-25",
        "reportTime": "2023-04-12T15:46:30.081"
    },
    "reportSummary": {
        "numberOfRatings": 1200,
        "averageScore": 3.8
    },
    "ratings": [
        {
            "date": "2023-01-01",
            "numberOfRatings": 100,
            "averageScore": 3.6
        },
        {
            "date": "2023-01-02",
            "numberOfRatings": 110,
            "averageScore": 3.2
        },
        {
            "date": "2023-01-03",
            "numberOfRatings": 50,
            "averageScore": 3.1
        }
    ]
}


export function RatingsOverviewTab() {

    // TODO Hamza use queryResult when backend is ready
    const smilyReportQueryResult = useApiQuery(fetchSmilyReportByPeriod, {
        queryName: "get-smily-report",
        dependencies: {},
    })

    // TODO Hamza use queryResult when backend is ready
    const dailyRatingReportQueryResult = useApiQuery(fetchDailyRatingsReportByPeriod, {
        queryName: "get-daily-rating-report",
        dependencies: {},
    })

    // TODO Hamza use queryResult when backend is ready
    const topicSummaryReportQueryResult = useApiQuery(fetchTopicSummaryReportByPeriod, {
        queryName: "get-topic-summary-report",
        dependencies: {},
    })


    return (
        <>
            <SelectSurvey />
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Smily smilyReport={smilyReportData} />
                <SatisfactionResponsesGraf dailyRating={dailyRatingReportData} />
            </Box>
            <SatisfactionResponsesWordCloud />


        </>
    );
}
